import { FC, ComponentProps } from 'react';
import { IFeatureBase } from 'mod/featureV2/interface';
import cn from 'classnames';

export type IProps = ComponentProps<'h2'> & {
    feature?: IFeatureBase;
};

export const FeatureTitle: FC<IProps> = ({ className, style, feature }) => {
    const { title, theme, } = feature || {};
    const { titleClassName } = theme || {};
    return !title ? null : (
        <h2
            className={cn('g-feature-title text-wrap', titleClassName, className)}
            style={style}
            dangerouslySetInnerHTML={{ __html: title }}
        />
    )
};
